import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

const BrokerLabel = ({ label, prefixIcon }) => (
  <div className="d-flex align-items-center">
    <label className="form-label mb-0">
      {prefixIcon}
      {label}
    </label>
    <OverlayTrigger
      overlay={brokerTooltip()}
      placement="top"
    >
      <FontAwesomeIcon className="ms-1" icon={faCircleInfo} size="lg"/>
    </OverlayTrigger>
  </div>
);

export default BrokerLabel;

const brokerTooltip = props => (
  <Tooltip id="primary-broker-tooltip" {...props}>
    You must include yourself or a broker you have permissions for to create this property
  </Tooltip>
);

BrokerLabel.propTypes = {
  label: PropTypes.string.isRequired,
  prefixIcon: PropTypes.node,
};
